import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router'
import { jobsSearchSchema } from '@/features/jobs/model'
import { JobsScreen } from '@/features/jobs/routes/jobs-screen'

export const Route = createFileRoute('/jobs')({
  // The list's filters live in the address (src/features/jobs/model.ts).
  validateSearch: jobsSearchSchema,
  component: JobsLayout,
})

function JobsLayout() {
  // A job's page owns the whole screen; the list shows when no job is open.
  const matches = useMatches()
  const hasChild = matches.some((match) => match.routeId === '/jobs/$jobId')
  const search = Route.useSearch()
  return hasChild ? <Outlet /> : <JobsScreen search={search} />
}
